import * as Sentry from "@sentry/react";
import store from "../redux/store";
import { OLD_STATE_KEY } from "../utils/persiststate";

export function captureSentryEvent({
  eventName,
  eventLevel = "log",
  data,
}: {
  eventName: string;
  eventLevel?: Sentry.SeverityLevel;
  data?: any;
}) {
  let stringifiedData = "";
  try {
    stringifiedData = data ? JSON.stringify(data) : "";
  } catch (error) {
    stringifiedData = "Data is not JSON serializable";
  }
  Sentry.captureEvent({
    message: eventName,
    level: eventLevel,
    extra: {
      data: stringifiedData,
    },
  });
}

export function getSentryMetaInfo() {
  const branchId = store.getState().businessReducer?.businessData?.branchId || "";
  const accountUUID = store.getState().businessReducer?.businessData?.accountUUID || "";
  const userId = store.getState().businessReducer?.userData?.userId || "";
  const businessUserId = store.getState().businessReducer?.userData?.businessUserId || "";
  const oldStateStr = localStorage.getItem(OLD_STATE_KEY);
  return {
    branchId,
    userId,
    businessUserId,
    accountUUID,
    oldReduxStateExists: !!oldStateStr,
  };
}
